<template>
  <div class="content">
    <!--列表-->
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>出口车型审核</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row type="flex" :gutter="20">
        <el-col :span="1.5">
          <el-button style="float: left" type="primary" @click="onAuditBatch" size="mini">批量审核</el-button>
        </el-col>

        <el-col :span="6.5">
          <div class="flex-row">
            <el-input
            v-model="where.model_name"
            style="width: 200px;margin-right:20px;"
            placeholder="车型名称"
            clearable
            size="mini"
          ></el-input>
          <el-date-picker
            v-model="where.date"
            type="date"
            placeholder="选择日期"
            size="mini">
          </el-date-picker>
          </div>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="index(where)" size="mini">查询</el-button>
        </el-col>
      </el-row>
      <el-tabs v-model="audit_type" @tab-click="index(where)">
        <el-tab-pane
          label="全部"
          name="99"
        />
        <el-tab-pane
          label="待审核"
          name="0"
        />
        <el-tab-pane
          label="审核成功"
          name="1"
        />
        <el-tab-pane
          label="审核驳回"
          name="2"
        />
        <el-tab-pane
          label="审核待替换"
          name="3"
        />
        <el-tab-pane
          label="审核已替换"
          name="4"
        />
      </el-tabs>
      <el-row style="margin-top: 10px">
        <el-table v-loading="loading" border :data="tableData" height="650" style="margin-bottom:5px" @selection-change="handleSelectionChange">
          <el-table-column fixed type="selection" width="55">
          </el-table-column>
          <el-table-column
            type="index"
            fixed
            label="序号"
            width="50"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="get_brand.brand_name"
            label="品牌名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="get_series.series_name"
            label="车系名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="get_model.model_name"
            label="车型名称"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="special_price_true"
            align="center"
            label="优惠成交价"
          >
          </el-table-column>
          <el-table-column
            prop="special_discount_max"
            align="center"
            label="降价幅度"
          >
          </el-table-column>
          <el-table-column
            prop="special_case"
            align="center"
            label="车源类型"
          >
          </el-table-column>
          <el-table-column
            prop="cityid"
            align="center"
            label="车源所在地"
          >
            <template slot-scope="scope">{{scope.row.get_city?scope.row.get_city.name:'暂无设置'}}</template>
          </el-table-column>
          <!-- <el-table-column
            prop="special_procedure"
            align="center"
            label="手续"
          >
          </el-table-column> -->
          <!-- <el-table-column
            prop="remark"
            align="center"
            label="备注"
          >
          </el-table-column> -->
          <!-- 0: 默认(审核中) 1：成功 2: 拒绝 3: 失败 -->
          <el-table-column
            prop="audit_type"
            align="center"
            label="审核状态"
          >
          <template slot-scope="scope">
            <el-tag v-if="!scope.row.audit_type">待审核</el-tag>
            <el-tag type="success" v-if="scope.row.audit_type == 1">审核成功</el-tag>
            <el-tag type="danger" v-if="scope.row.audit_type == 2">审核驳回</el-tag>
            <el-tag type="danger" v-if="scope.row.audit_type == 3">审核待替换</el-tag>
            <el-tag type="danger" v-if="scope.row.audit_type == 4">审核已替换</el-tag>
          </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="销售名称"
          >
            <template slot-scope="scope">{{scope.row.get_user?scope.row.get_user.username:'暂未设置'}}</template>
          </el-table-column>
          <el-table-column
            align="center"
            label="销售电话"
          >
            <template slot-scope="scope">{{scope.row.get_user?scope.row.get_user.phone:'暂未设置'}}</template>
          </el-table-column>
          <el-table-column prop="created_at" align="center" label="时间">
            <template slot-scope="scope">{{$utils.isDate(scope.row.created_at)}}</template>
          </el-table-column>
          <el-table-column
            prop="sort"
            align="center"
            label="排序"
          >
          </el-table-column>
          <el-table-column
            prop="address"
            align="center"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="onAudit(scope.row)"
                type="primary" 
                plain
                v-if="scope.row.audit_type == 0 || scope.row.audit_type == 3"
                >审核</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="index(where)"
          :current-page.sync="where.page"
          :page-size="where.pagesize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </el-row>
    </div>
    <!-- 添加，编辑 -->
    <el-dialog
      title="出口车型"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      v-if="dialogVisible"
    >
      <myForm
        @emincarofer="onemincarofer"
        :row="updatedList"
        :edit="isupdata"
      ></myForm>
    </el-dialog>
  </div>
</template>

<script>
import myForm from "./form";
import {
  car_special_offer,
  addcar_special_offer,
  modifycar_special_offer,
  addcar_special_offer_auditBatch,
} from "../../api/api";
export default {
  name: "car-special-offer",
  components: { myForm },
  data() {
    return {
      tableData: [],
      keyword: [],
      loading: false,
      where: {
        // modelid: "",
        model_name: '',
        page: 1,
        pagesize: 10,
      },
      audit_type: '99',
      total: 0,
      dialogVisible: false,
      isupdata: false,
      isupdataid: 0,
      updatedList: "",
      multipleSelection: [], // 多选
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      const param = this.where;
      param.audit_type = this.audit_type == '99' ? null : this.audit_type;
      await car_special_offer(param).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data).data;
        this.total = data.total;
        this.tableData = data.data;
        this.loading = false;
      });
    },
    // 编辑
    async onemincarofer(obj) {
      if (obj.form) {
        if (this.isupdata == false) {
          await addcar_special_offer(obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          });
        }
        if (this.isupdata == true) {
          await modifycar_special_offer(this.isupdataid, obj.form).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      }
      this.isupdata = false;
      this.isupdataid = 0;
      this.updatedList = "";
      this.dialogVisible = false;
      this.getList();
    },
    // 审核
    onAudit(scope) {
      this.dialogVisible = true;
      this.isupdataid = scope.id;
      this.isupdata = true;
      this.updatedList = scope;
    },
    // 批量审核
    async onAuditBatch() {
      // this.dialogVisible = true;
      if(!this.multipleSelection.length) {
        this.$message.error("请选择数据进行审批");
        return;
      }
      const auditObj = {}
      const ids = this.multipleSelection.map((item)=> item.id);
      auditObj.ids = ids;
      auditObj.audit_type = 1;
      auditObj.audit_content = '审核成功';

      await addcar_special_offer_auditBatch(auditObj).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data);
        if (data.code == 200) {
          this.$message.success(data.msg);
          this.getList();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 批量选中
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    delMessage(scope) {
      this.$confirm("此操作将拒绝数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // delcar_special_offer(scope.id).then((msg) => {
          //   let { data } = msg;
          //   data = JSON.parse(data);
          //   if (data.code == 200) {
          //     this.getList();
          //     this.$message.success(data.msg);
          //   } else {
          //     this.$message.error(data.msg);
          //   }
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleSizeChange(val) {
      this.where.pagesize = val;
      this.getList();
    },
    index(e) {
      console.log(this.where);
      this.where = e;
      this.getList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
  filters: {
    getImg: function (value) {
      if (value == "[]") return "";
      let res = JSON.parse(value);
      let url = window.location.origin + "/" + res[0].response.path;
      return url;
    },
    getText: function (value) {
      if (!value || value == "") return "";
      let res_json = JSON.parse(value);
      let res = "";
      for (var i = 0; i < res_json.length; i++) {
        res += i + 1 + ":" + res_json[i] + "\r\n";
      }
      return res;
    },
  },
};
</script>

<style scoped lang="scss">
.flex-row{
  display: flex;
  align-items: center;
}
.el-col-3 {
  width: 210px;
}
.el-col-1 {
  width: 68px;
}
.el-breadcrumb {
  margin-bottom: 15px;
}
</style>

